export default __webpack_public_path__ + "static/media/IBimageSwinglegretraction2.b5ea8da5.png";